/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import SpecialInitiativesPublishedDate from "@/models/interfaces/SpecialInitiativesPublishedDate";
import Broadcaster from "@/models/SpecialInitiatives/Broadcaster";
import { Product } from "@/models/SpecialInitiatives/Product";

export const GET_SPECIAL_INITIATIVES_BROADCASTERS =
  "get_special_initiatives_broadcasters";
export const GET_SPECIAL_INITIATIVES_MODULES_BROADCASTERS =
  "get_special_initiatives_modules_broadcasters";
export const GET_SPECIAL_INITIATIVES_BROADCAST =
  "get_special_initiatives_broadcast";
export const GET_SPECIAL_INITIATIVES_ = "get_special_initiatives_broadcast";
export const MAX_TOP_INVESTORS = 100;

@Component
export default class SpecialInitiativesMixin extends Vue {
  getLastPublishedDate(tag: string): Promise<SpecialInitiativesPublishedDate> {
    const url =
      API_ENDPOINT + `/special_initiatives/weekly_tasks/last_published`;

    const response = this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
    return response;
  }

  getBroadcasters(filters: any): Promise<Broadcaster[]> {
    const filterString = this.initBroadcastersRequestFilter(filters);
    const url =
      API_ENDPOINT + `/special_initiatives/search${filterString}&per=all`;
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCASTERS,
      url: url,
      method: "GET",
    });
    return response;
  }

  getProducts(filters: any): Promise<Product[]> {
    const filterString = this.initProductsRequestFilter(filters);
    const url =
      API_ENDPOINT +
      `/special_initiatives/search_products${filterString}&per=all`;
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCASTERS,
      url: url,
      method: "GET",
    });
    return response;
  }

  getBrandProducts(filters: any, companyId: string): Promise<Product[]> {
    const filterString = this.initProductsRequestFilter(filters);
    const url =
      API_ENDPOINT +
      `/special_initiatives/search_brands${filterString}&filter[company]=${companyId}&per=all`;
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCASTERS,
      url: url,
      method: "GET",
    });
    return response;
  }

  getProductsForBrand(
    filters: any,
    brandId?: string | undefined,
    productId?: string | undefined
  ): Promise<Product[]> {
    const filterString = this.initProductsRequestFilter(filters);
    const filterBrand =
      brandId === undefined ? "" : `&filter[brand]=${brandId}`;
    const filterProduct =
      productId === undefined ? "" : `&filter[product]=${productId}`;
    const url =
      API_ENDPOINT +
      `/special_initiatives/search_brand_products${filterString}&per=all${filterBrand}${filterProduct}`;
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCASTERS,
      url: url,
      method: "GET",
    });
    return response;
  }

  getCompanyBroadcasters(
    filters: any,
    companyId: string
  ): Promise<Broadcaster[]> {
    const filterString = this.initBroadcastersRequestFilter(filters);
    const url =
      API_ENDPOINT +
      `/special_initiatives/search${filterString}&filter[company]=${companyId}&per=all`;
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCASTERS,
      url: url,
      method: "GET",
    });
    return response;
  }

  getBrandBroadcasters(filters: any, brandId: string): Promise<Broadcaster[]> {
    const filterString = this.initBroadcastersRequestFilter(filters);
    const url =
      API_ENDPOINT +
      `/special_initiatives/search${filterString}&filter[brand]=${brandId}&per=all`;
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCASTERS,
      url: url,
      method: "GET",
    });
    return response;
  }

  getProductBroadcasters(
    filters: any,
    productId: string
  ): Promise<Broadcaster[]> {
    const filterString = this.initBroadcastersRequestFilter(filters);
    const url =
      API_ENDPOINT +
      `/special_initiatives/search_modules${filterString}&filter[product]=${productId}&per=all`;
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_MODULES_BROADCASTERS,
      url: url,
      method: "GET",
    });
    return response;
  }

  async getBroadcast(broadcastId: number) {
    const url = `${API_ENDPOINT}/special_initiatives/broadcasts/${broadcastId}`;

    const params = {
      include:
        "broadcast_modules,broadcast_modules.module,broadcast_modules.module.module_typology,broadcast_modules.module.spot_duration",
    };

    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCAST,
      url: url,
      method: "GET",
      params: params,
    });

    return response;
  }

  async getCompaniesTopInvestors(filters: any) {
    const url = `${API_ENDPOINT}/special_initiatives/top_investors/companies.json`;
    const request = this.initTopInvestorsFilter(filters);
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCAST,
      url: url,
      method: "POST",
      data: request,
    });

    return response;
  }

  async getBrandsTopInvestors(filters: any) {
    const url = `${API_ENDPOINT}/special_initiatives/top_investors/brands.json`;
    const request = this.initTopInvestorsFilter(filters);
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCAST,
      url: url,
      method: "POST",
      data: request,
    });

    return response;
  }

  async getProductsTopInvestors(filters: any) {
    const url = `${API_ENDPOINT}/special_initiatives/top_investors/products.json`;
    const request = this.initTopInvestorsFilter(filters);
    const response = this.$store.dispatch("http/request", {
      tag: GET_SPECIAL_INITIATIVES_BROADCAST,
      url: url,
      method: "POST",
      data: request,
    });

    return response;
  }

  private initBroadcastersRequestFilter(filters: any) {
    let request: { [key: string]: string } = {};
    request = Object.assign(
      {},
      request,
      this.filtersWeeksToDate(filters),
      this.filtersGeographicArea(filters),
      this.filtersModuleTypology(filters),
      this.filtersTaxonomy(filters),
      this.filtersTimeGranularity(filters)
    );

    let filterString = "?";
    for (const key in request) {
      filterString = `${filterString}${key}=${request[key]}&`;
    }
    return filterString.substr(0, filterString.length - 1);
  }

  private initProductsRequestFilter(filters: any) {
    let request: { [key: string]: string } = {};
    let subjectFilter =
      filters.clientSubject === "taxonomies"
        ? this.filtersTaxonomy.bind(this)
        : this.filtersGroup.bind(this);

    request = Object.assign(
      {},
      request,
      this.filtersWeeksToDate(filters),
      this.filtersGeographicArea(filters),
      this.filtersModuleTypology(filters),
      subjectFilter(filters)
    );

    let filterString = "?";
    for (const key in request) {
      filterString = `${filterString}${key}=${request[key]}&`;
    }
    return filterString.substr(0, filterString.length - 1);
  }

  private initTopInvestorsFilter(filters: any) {
    let request: { [key: string]: string } = {};
    request = Object.assign(
      {},
      request,
      this.filtersWeeksToDate(filters),
      this.filtersPer(),
      {
        filter: Object.assign(
          {},
          this.filtersPostGeographicArea(filters),
          this.filtersPostModuleTypology(filters),
          this.filtersPostTaxonomy(filters),
          this.filtersSubjectKind(filters),
          this.filtersSubjects(filters),
          this.filtersGroupType(filters)
        ),
      }
    );

    return request;
  }

  private filtersPer() {
    return {
      per: MAX_TOP_INVESTORS,
    };
  }

  private filtersSubjectKind(filters: any) {
    const kind = filters.subjectKind;
    if (kind) {
      return {
        subject_type: kind.id,
      };
    }
  }

  private filtersSubjects(filters: any) {
    const ids = filters.subjectIds;
    if (ids) {
      return {
        ids: ids.join(","),
      };
    }
  }

  private filtersGroupType(filters: any) {
    const unitOfMeasurement = filters.unitOfMeasurement;
    if (unitOfMeasurement) {
      return {
        group_type: unitOfMeasurement === "spots" ? "detections" : "seconds",
      };
    }
  }

  private filtersWeeksToDate(filters: any) {
    const range = filters.weekRange;
    if (range) {
      const [w1, y1, w2, y2] = range.split(",");
      const moment = this.$moment().isoWeekday(1);

      moment.isoWeek(Number.parseInt(w1));
      moment.isoWeekYear(Number.parseInt(y1));
      const startsAt = encodeURIComponent(
        moment.startOf("isoWeek").format("YYYY-MM-DD")
      );

      moment.isoWeek(Number.parseInt(w2));
      moment.isoWeekYear(Number.parseInt(y2));
      const endsAt = encodeURIComponent(
        moment.endOf("isoWeek").format("YYYY-MM-DD")
      );

      return {
        startsAt,
        endsAt,
      };
    }
  }

  private filtersPostGeographicArea(filters: any) {
    if (filters.area) {
      return { geographic_area: encodeURIComponent(filters.area) };
    }
  }

  private filtersPostModuleTypology(filters: any) {
    if (filters.moduleTypology) {
      return { module_typology: encodeURIComponent(filters.moduleTypology) };
    }
  }

  private filtersGeographicArea(filters: any) {
    if (filters.area) {
      return { "filter[geographic_area]": encodeURIComponent(filters.area) };
    }
  }

  private filtersModuleTypology(filters: any) {
    if (filters.moduleTypology) {
      return {
        "filter[module_typology]": encodeURIComponent(filters.moduleTypology),
      };
    }
  }

  private filtersGroup(filters: any) {
    if (filters.group) {
      return { "filter[group]": filters.group.id };
    }
  }

  private filtersPostTaxonomy(filters: any) {
    if (filters.clientSubject === "taxonomies") {
      if (filters.subjectSector && filters.subjectSector != "") {
        return { sector: filters.subjectSector };
      }
      if (filters.subjectCategory && filters.subjectCategory != "") {
        return { category: filters.subjectCategory };
      }
      if (filters.subjectClass && filters.subjectClass != "") {
        return { class: filters.subjectClass };
      }
    }
    if (filters.sector && filters.sector != "") {
      return { sector: filters.sector };
    }
    if (filters.category && filters.category != "") {
      return { category: filters.category };
    }
    if (filters.class && filters.class != "") {
      return { class: filters.class };
    }
  }

  private filtersTaxonomy(filters: any) {
    if (filters.clientSubject === "taxonomies") {
      if (filters.subjectSector && filters.subjectSector != "") {
        return { "filter[sector]": filters.subjectSector };
      }
      if (filters.subjectCategory && filters.subjectCategory != "") {
        return { "filter[category]": filters.subjectCategory };
      }
      if (filters.subjectClass && filters.subjectClass != "") {
        return { "filter[class]": filters.subjectClass };
      }
    }
    if (filters.sector && filters.sector != "") {
      return { "filter[sector]": filters.sector };
    }
    if (filters.category && filters.category != "") {
      return { "filter[category]": filters.category };
    }
    if (filters.class && filters.class != "") {
      return { "filter[class]": filters.class };
    }
  }

  private filtersTimeGranularity(filters: any) {
    if (filters.timeGranularity) {
      return {
        "filter[time_granularity]": encodeURIComponent(filters.timeGranularity),
      };
    }
  }
}
